import { useCallback } from "react";

import { langCodeToJapanese } from "@/lib/chillnn/lang-code";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { ExistingRoomI18nUpdateMutation } from "./mutation";
import { viewModelToRoomI18nInputConverter } from "../../_common/view-model-to-room-input";

import type { ProductRoomI18nFormModel } from "../../../type";

export const useRoomI18nEditMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(ExistingRoomI18nUpdateMutation);

	const onUpdateRoom18n = useCallback(
		async (
			viewModel: ProductRoomI18nFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToRoomI18nInputConverter({ viewModel: viewModel });

			const { lang } = input;
			const langCodeText = langCodeToJapanese(lang);

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: `部屋(${langCodeText})を更新しました`,
				});
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return { onUpdateRoom18n };
};
